import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './Login.module.css';
import apiService from '../services/api';

function Login() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        // 에러 초기화
        if (error) {
            setError('');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);
        setError('');

        try {
            // 로그인 API 호출
            const loginResponse = await apiService.loginUser(formData.email, formData.password);
            
            console.log('Login response:', loginResponse);
            
            // 토큰이 저장되었는지 확인
            const token = localStorage.getItem('userToken');
            if (!token) {
                console.error('Token not saved after login. Response:', loginResponse);
                throw new Error('토큰 저장에 실패했습니다.');
            }
            
            // 사용자 정보 가져오기 (실패해도 로그인은 성공으로 처리)
            try {
                const userInfo = await apiService.getUserInfo();
                console.log('Login successful, user info:', userInfo);
            } catch (userInfoError) {
                console.warn('Failed to get user info, but login was successful:', userInfoError);
                // 사용자 정보를 가져오지 못해도 로그인은 성공으로 처리
            }
            
            // 메인 페이지로 이동 후 새로고침하여 Header 업데이트
            navigate('/');
            window.location.reload();
        } catch (error) {
            console.error('Login error:', error);
            
            // 에러 메시지 설정
            const errorMessage = error.message || '로그인에 실패했습니다.';
            
            if (errorMessage.includes('승인') || errorMessage.includes('PENDING') || errorMessage.includes('REJECTED')) {
                setError('회원가입이 승인되지 않았습니다. 관리자 승인 후 로그인 가능합니다.');
            } else {
                setError('이메일 또는 비밀번호가 올바르지 않습니다.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className={styles.loginWrap}>
            <div className={styles.loginContainer}>
                <div className={styles.loginBox}>
                    <h2 className={styles.loginTitle}>로그인</h2>
                    <form onSubmit={handleSubmit} className={styles.loginForm}>
                        {error && (
                            <div className={styles.errorMessage}>
                                {error}
                            </div>
                        )}
                        <div className={styles.formGroup}>
                            <label htmlFor="email" className={styles.label}>이메일</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className={styles.input}
                                placeholder="이메일을 입력하세요" 
                                required
                                disabled={isSubmitting}
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label htmlFor="password" className={styles.label}>비밀번호</label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                className={styles.input}
                                placeholder="비밀번호를 입력하세요"
                                required
                                disabled={isSubmitting}
                            />
                        </div>
                        {/*   <div className={styles.options}>
                            <label className={styles.checkboxLabel}>
                                <input type="checkbox" className={styles.checkbox} />
                                <span>로그인 상태 유지</span>
                            </label>
                            <Link to="/" className={styles.findLink}>비밀번호 찾기</Link>
                        </div> */}
                        <button 
                            type="submit" 
                            className={styles.submitButton}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? '로그인 중...' : '로그인'}
                        </button>
                    </form>
                    <div className={styles.signupSection}>
                        {/*   <span>정회원 가입신청 하러가기</span> */}
                        <Link to="/signup" className={styles.signupLink}>정회원 가입신청</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;

